/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationMetadata } from './ConversationMetadata';
import {
    ConversationMetadataFromJSON,
    ConversationMetadataFromJSONTyped,
    ConversationMetadataToJSON,
    ConversationMetadataToJSONTyped,
} from './ConversationMetadata';

/**
 * Model for chat responses.
 * @export
 * @interface ChatResponse
 */
export interface ChatResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatResponse
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof ChatResponse
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof ChatResponse
     */
    role?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatResponse
     */
    instanceIds?: Array<string> | null;
    /**
     * 
     * @type {ConversationMetadata}
     * @memberof ChatResponse
     */
    conversationMetadata?: ConversationMetadata | null;
}

/**
 * Check if a given object implements the ChatResponse interface.
 */
export function instanceOfChatResponse(value: object): value is ChatResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function ChatResponseFromJSON(json: any): ChatResponse {
    return ChatResponseFromJSONTyped(json, false);
}

export function ChatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'timestamp': (new Date(json['timestamp'])),
        'role': json['role'] == null ? undefined : json['role'],
        'instanceIds': json['instance_ids'] == null ? undefined : json['instance_ids'],
        'conversationMetadata': json['conversation_metadata'] == null ? undefined : ConversationMetadataFromJSON(json['conversation_metadata']),
    };
}

export function ChatResponseToJSON(json: any): ChatResponse {
    return ChatResponseToJSONTyped(json, false);
}

export function ChatResponseToJSONTyped(value?: ChatResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'timestamp': ((value['timestamp']).toISOString()),
        'role': value['role'],
        'instance_ids': value['instanceIds'],
        'conversation_metadata': ConversationMetadataToJSON(value['conversationMetadata']),
    };
}

